export const iconFontAwesomeMathematicsDivide = (
	<i className="fa-solid fa-divide"></i>
);
